/**
 * 判断值是否为字符串
 * @return 是否为字符串
 */
export default function isString(value) {
    return typeof value === 'string';
}
//# sourceMappingURL=is-string.js.map